const guiColors = {
    'motion-primary': 'hsla(300, 53%, 60%, 1)',
    'motion-primary-transparent': 'hsla(300, 53%, 60%, 0.9)',
    'motion-tertiary': 'hsla(300, 48%, 50%, 1)',

    'looks-secondary': 'hsla(300, 53%, 60%, 1)',
    'looks-transparent': 'hsla(300, 53%, 60%, 0.35)',
    'looks-light-transparent': 'hsla(300, 53%, 60%, 0.15)',
    'looks-secondary-dark': 'hsla(300, 48%, 50%, 1)',

    'extensions-primary': 'hsla(310, 45%, 60%, 1)',
    'extensions-tertiary': 'hsla(310, 45%, 35%, 1)',
    'extensions-transparent': 'hsla(310, 45%, 60%, 0.35)',
    'extensions-light': 'hsla(310, 30%, 80%, 1)',

    'drop-highlight': 'hsl(300, 53%, 73%)'
};

const blockColors = {
    checkboxActiveBackground: 'hsl(300, 53%, 60%)',
    checkboxActiveBorder: 'hsl(300, 48%, 50%)'
};

export {
    guiColors,
    blockColors
};